import "./style.scss";

const IntroSection = () => {
	return (
		<section className="intro-section">
			<div className="intro-section__image">
				<img
					src="/images/main/main-logo.png"
					alt="Main Logo"
					className="intro-section__logo"
				/>
				<picture>
					<source srcSet="/images/main/main-1-mo.webp" media="(max-width: 768px)" />
					<img
						src="/images/main/main-1.webp"
						alt="Main Image"
						className="intro-section__image"
					/>
				</picture>
			</div>
		</section>
	);
};

export default IntroSection;
